'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _directionalMarkersGroup = require('./directionalMarkersGroup');

var _directionalMarkersGroup2 = _interopRequireDefault(_directionalMarkersGroup);

var _invalidCharsGroup = require('./invalidCharsGroup');

var _invalidCharsGroup2 = _interopRequireDefault(_invalidCharsGroup);

var _punct = require('./punct');

var _punct2 = _interopRequireDefault(_punct);

var _spacesGroup = require('./spacesGroup');

var _spacesGroup2 = _interopRequireDefault(_spacesGroup);

var _stringSupplant = require('../lib/stringSupplant');

var _stringSupplant2 = _interopRequireDefault(_stringSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var invalidDomainChars = (0, _stringSupplant2.default)('#{punct}#{spacesGroup}#{invalidCharsGroup}#{directionalMarkersGroup}', {
  punct: _punct2.default,
  spacesGroup: _spacesGroup2.default,
  invalidCharsGroup: _invalidCharsGroup2.default,
  directionalMarkersGroup: _directionalMarkersGroup2.default
}); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = invalidDomainChars;
module.exports = exports['default'];